import { render, staticRenderFns } from "./AntiLostDialog.vue?vue&type=template&id=22a1638b&scoped=true&"
import script from "./AntiLostDialog.vue?vue&type=script&lang=js&"
export * from "./AntiLostDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1638b",
  null
  
)

export default component.exports